/* ************************* */
//
// This file will be made available as /assets/marketplace_search.js by webpack,
// including *all* imported libraries and networked dependencies here and elsewhere
//
/* ************************* */

const instantsearch = require("instantsearch.js").default;
const {
    searchBox,
    hits,
    pagination,
    refinementList,
    currentRefinements,
    panel,
    configure,
    clearRefinements,
} = require("instantsearch.js/es/widgets"); // https://www.algolia.com/doc/api-reference/widgets/js/
const fetch = require("node-fetch");

const { paths } = require("../../sugarconfig/");
const {
    getQueryParams,
    getAsyncJSON,
    cloneTemplate,
} = require("../modules/shared");
const { showFlashError } = require("../modules/ui_utils");
const { isDefined } = require("../../modules/sw-utilities.js");
const { SUGARWOD } = require("../../modules/sw-constants");

const ORIGIN_URL = window.location.origin;
const CSRF_PROXY_URL = `${ORIGIN_URL}/proxy/csrf-token-proxy`;

let theTaxonomyCategories = [],
    theTaxonomyCategoriesIndexedByKey = {},
    thePublishers = [],
    canSeeTestEcommProducts = false,
    thePublishersIndexedByName = {},
    thePublishersIndexedById = {};

$(document).ready(function () {
    if (window.CUR_ATH_ID) {
        _SugarWOD.session.getAffiliate(function (aff) {
            if (aff.affFeatures.features) {
                let affFeatures = aff.affFeatures.features;

                affFeatures.map((affFeature) => {
                    if (affFeature == "ecommerce_enabled") {
                        canSeeTestEcommProducts = true;
                    }
                });
            }
        });
    }

    new ReferenceObjects(
        {
            marketplaceProductTaxonomy: true,
        },
        function (refObjs) {
            theTaxonomyCategories = refObjs.marketplaceProductTaxonomy;
            theTaxonomyCategoriesIndexedByKey = _.indexBy(
                theTaxonomyCategories,
                "key"
            );
            fetchPublishers();
        }
    );
});

const fetchPublishers = () => {
    const { public_api_prefix } = paths;
    const url = public_api_prefix + "/marketplace/publishers";
    const data = {};

    getAsyncJSON(url, data, "", function (result) {
        if (result.success) {
            thePublishers = result.data;
            thePublishersIndexedByName = {};
            thePublishersIndexedById = _.indexBy(thePublishers, "id");
            for (let i = 0; i < thePublishers.length; i++) {
                thePublishersIndexedByName[thePublishers[i].name] =
                    thePublishers[i];
            }

            try {
                initializeSearchUI();
            } catch (err) {
                console.log(err);
            }
        } else {
            showFlashError(result.message);
        }
    });
};

const customSearchClient = {
    async search(request) {
        try {
            const csrfResponse = await fetch(CSRF_PROXY_URL);
            const csrfToken = await csrfResponse.headers.get("X-CSRF-TOKEN");
            const ALGOLIA_SEARCH_PROXY_URL = `${ORIGIN_URL}/proxy/algolia-search-proxy`;

            const response = await fetch(ALGOLIA_SEARCH_PROXY_URL, {
                method: "POST",
                headers: {
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json; charset=utf-8",
                    "X-CSRF-TOKEN": csrfToken,
                },
                body: JSON.stringify({ request: request }),
            });
            const data = await response.json();
            return data;
        } catch (error) {
            console.error(error);
            return { error };
        }
    },
};

const initializeSearchUI = async () => {
    const search = instantsearch({
        indexName: "Products",
        searchClient: customSearchClient,
    });

    search.addWidgets([
        searchBox({
            container: "#searchbox",
            placeholder: "Search Marketplace",
            cssClasses: {
                input: "searchbox-input",
                submit: "searchbox-submit",
                reset: "searchbox-reset",
            },
        }),
        pagination({
            container: "#pagination",
            cssClasses: {
                list: "pagination-list",
                item: "pagination-item",
                link: "pagination-link",
                selectedItem: "pagination-selected-item",
                disabledItem: "pagination-disabled-item",
            },
        }),
        clearRefinements({
            container: "#clear-refinements",
            cssClasses: {
                button: "btn btn-white btn-full-width",
            },
            templates: {
                resetLabel() {
                    return "Clear all";
                },
            },
        }),
    ]);

    // results (hits)
    search.addWidgets(buildHitsWidget());

    // facets
    search.addWidgets(buildRefinementsWidget());

    // current refinements (selected facets)
    search.addWidgets(buildCurrentRefinementsWidget());

    // support pre-selecting audience facets
    // url formatted like /marketplace/search?audience=individual
    const params = getQueryParams(document.location.search);
    if (
        isDefined(params.audience) &&
        (params.audience === "individual" || params.audience === "class")
    ) {
        // configure defaults
        search.addWidgets([
            configure({
                // select default values
                disjunctiveFacetsRefinements: {
                    facet_program_audience: [params.audience],
                },
            }),
        ]);

        // remove from url to ignore on next render
        history.pushState(null, null, window.location.pathname);
    }

    search.start();

    // bind elements after rendering
    const onSearchRender = () => {
        // result card
        $(".mkt-search-hit-row").on("click", (e) => {
            // don't affect anchor tags
            if (!isDefined(e.target.href)) {
                // use data attribute from parent to send to product page
                const parentId = e.currentTarget.id;
                window.location.href = $("#" + parentId).attr("data-page-url");
            }
        });
    };
    search.on("render", onSearchRender);

    // mobile facets button
    const facets = $("#facets");
    $("#mobile-filters-toggle").on("click", function () {
        const isInitialized = facets.hasClass("on");
        if (!isInitialized) {
            $(this).addClass("on");
            facets.addClass("on").animate({ left: 0 });
        } else {
            closeMobileFacets();
        }
    });

    $(".close-mobile-facets", facets).on("click", function () {
        closeMobileFacets();
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: $("#marketplace-search-results").offset().top,
            },
            500
        );
    });

    // Store the window width
    let windowWidth = $(window).width();

    // resize event
    $(window).resize(function () {
        // check window width has actually changed and it's not just iOS triggering a resize event on scroll
        if ($(window).width() !== windowWidth) {
            // update the window width for next time
            windowWidth = $(window).width();

            // reset mobile facets visibility
            $("#mobile-filters-toggle").removeClass("on");
            facets.removeClass("on").removeAttr("style");
        }
    });

    // more results button
    const moreResultsButton = $("#more-results-above");

    // show moreResultsButton when the results are out of view
    $(window).scroll(function () {
        const hitsEl = $("#hits");
        const bottom_of_object =
            hitsEl.offset().top + hitsEl.outerHeight() - 30;
        moreResultsButton.toggleClass(
            "hidden",
            bottom_of_object > $(window).scrollTop()
        );
    });

    // scroll to top of page on click
    moreResultsButton.on("click", function () {
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: $("#marketplace-search-results").offset().top,
            },
            500
        );
    });
};

function closeMobileFacets() {
    $("#mobile-filters-toggle").removeClass("on");
    $("#facets").removeClass("on").animate({ left: -1000 });
}
const getTemplateItemDataFromItems = (item) => {
    const { facet_product_type, workoutPublisher, slug, parseId } = item;
    const publisher = thePublishersIndexedById[workoutPublisher.id];

    let primaryColor = "";
    let accentColor = "";
    let encodedPrimaryColor = "";
    let encodedAccentColor = "";

    if (publisher && publisher.publishingAffiliate) {
        primaryColor = publisher.publishingAffiliate.primaryColor || "";
        accentColor = publisher.publishingAffiliate.accentColor || "";

        encodedPrimaryColor = encodeURIComponent(primaryColor);
        encodedAccentColor = encodeURIComponent(accentColor);
    }

    let checkoutUrl;
    const isPhysicalProduct =
        facet_product_type && facet_product_type[0] === "physical_goods";

    // url helpers
    const publisherPageUrl = `/marketplace/${workoutPublisher.slugOrId}`;
    const ecommerceUImerchantPageUrl = `/marketplace/storefront/${workoutPublisher.id}`; // TODO: work with ecommerce team to get this working

    const productPageUrl = `${publisherPageUrl}/${slug}`;
    const ecommerceUIproductPageUrl = `/marketplace/product-page/${parseId}`; // TODO: work with ecommerce team to get this working

    if (isLoggedIn) {
        checkoutUrl = `${productPageUrl}/checkout?&primaryColor=${encodedPrimaryColor}&accentColor=${encodedAccentColor}&publisherName=${workoutPublisher.name}`;
    } else {
        const redirectUrl = `${productPageUrl}/checkout`;
        checkoutUrl = `/marketplace-signup?url=${redirectUrl}&primaryColor=${encodedPrimaryColor}&accentColor=${encodedAccentColor}&publisherName=${workoutPublisher.name}`;
    }

    return {
        ...item,
        isPhysicalProduct,
        publisherPageUrl,
        ecommerceUImerchantPageUrl,
        productPageUrl,
        ecommerceUIproductPageUrl,
        checkoutUrl,
    };
};

const updateCheckoutUrl = (item) => {
    const { isECSProduct, objectID, variants } = item;
    if (isECSProduct) {
        const sw_local_cur_aff = JSON.parse(
            localStorage.getItem("sw_local/cur_aff")
        );
        const memberId = global.CUR_ATH_ID || sw_local_cur_aff.athlete.id;
        const gymId = global.CUR_AFF_ID || sw_local_cur_aff.id;

        const shopifyCheckoutApiRequestBody = {
            contextApp: SUGARWOD,
            gymId: gymId,
            memberId: memberId,
            quantity: 1,
            variantId: variants[0].id,
        };

        fetch(CSRF_PROXY_URL)
            .then((res) => res.headers.get("X-CSRF-TOKEN"))
            .then((csrfToken) => {
                const SHOPIFY_CHECKOUT_API_URL = `${ORIGIN_URL}/api/proxy/shopify-checkout-proxy`;
                fetch(SHOPIFY_CHECKOUT_API_URL, {
                    method: "POST",
                    headers: {
                        Accept: "application/json, text/plain, */*",
                        "Content-Type": "application/json",
                        "X-CSRF-TOKEN": csrfToken,
                    },
                    body: JSON.stringify(shopifyCheckoutApiRequestBody),
                })
                    .then((response) => {
                        if (response.ok) {
                            return response.json().then((data) => {
                                if (!data.message) {
                                    const ecommerceUICheckoutUrl = data.webUrl;
                                    const querySelector = `a[data-linkId="${objectID}"]`;
                                    $(querySelector).attr(
                                        "href",
                                        ecommerceUICheckoutUrl
                                    );
                                } else {
                                    console.error(data.message);
                                    const querySelector = `a[data-linkId="${objectID}"]`;
                                    $(querySelector).hide();
                                }
                            });
                        } else {
                            const querySelector = `a[data-linkId="${objectID}"]`;
                            $(querySelector).hide();
                        }
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                    });
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }
};

const itemTemplate = (item) => {
    const {
        objectID,
        isPhysicalProduct,
        isECSProduct,
        ecommerceUIproductPageUrl,
        productPageUrl,
        ecommerceUImerchantPageUrl,
        publisherPageUrl,
        facet_brand,
        workoutPublisher,
        priceDisplay,
        facet_program_audience,
        name,
        summary,
        checkoutUrl,
        imageURL,
    } = getTemplateItemDataFromItems(item);

    // template
    const searchHitTemplateElement = cloneTemplate(
        "mkt-search-hit-template",
        objectID
    );

    searchHitTemplateElement.attr(
        "data-page-url",
        isPhysicalProduct && isECSProduct
            ? ecommerceUIproductPageUrl
            : productPageUrl
    );

    // image
    $(
        ".mkt-search-hit-item-image .img-responsive",
        searchHitTemplateElement
    ).attr("src", imageURL);

    // publisher
    $(".publisher-name", searchHitTemplateElement)
        .attr(
            "href",
            isPhysicalProduct && isECSProduct
                ? ecommerceUImerchantPageUrl
                : publisherPageUrl
        )
        .text(
            facet_brand
                ? facet_brand[0]
                : workoutPublisher
                ? workoutPublisher.name
                : ""
        );

    // price
    $(".price-display", searchHitTemplateElement).text(priceDisplay);

    // product details
    $(".product-name", searchHitTemplateElement).text(name);
    $(".product-summary", searchHitTemplateElement).text(
        summary.replace(/\n/g, "")
    );

    // button
    if (isPhysicalProduct) {
        $(".button-description", searchHitTemplateElement).removeClass(
            "hidden"
        );
        $(".button-description .name", searchHitTemplateElement).text(
            workoutPublisher.name
        );
        $(".product-link", searchHitTemplateElement)
            .text("Checkout")
            .addClass("product-link-physical");
    }

    $(".product-link", searchHitTemplateElement).attr("href", checkoutUrl);

    $(".product-link", searchHitTemplateElement).attr("data-linkId", objectID);

    // class or individual
    $(".product-audience", searchHitTemplateElement).text(
        facet_program_audience ? facet_program_audience[0] : ""
    );

    updateCheckoutUrl(item, searchHitTemplateElement);

    return searchHitTemplateElement[0].outerHTML;
};

function buildHitsWidget() {
    return [
        hits({
            container: "#hits",
            cssClasses: {
                list: "hits-list",
                item: "hits-item",
            },
            transformItems(items) {
                return items.map((item) => {
                    if (!canSeeTestEcommProducts && item.isECSProduct) {
                        return;
                    } else {
                        return item;
                    }
                });
            },
            templates: {
                item: itemTemplate,
                empty: "No results for <q>{{ query }}</q>",
            },
        }),
    ];
}

function buildRefinementsWidget() {
    const facetsContainer = $("#facets");
    const facetPanelsContainer = $("#facet-panels", facetsContainer);

    // use list of taxCats to create elements and theme facets with our display names
    return _.map(theTaxonomyCategories, (taxCat) => {
        // add category wrapper to facet container
        facetPanelsContainer.append($("<div/>").prop("id", taxCat.key));

        // customize header of refinement list
        const refinementListWithPanel = panel({
            templates: {
                header: "<h2>" + taxCat.name + "</h2>",
                collapseButtonText:
                    '<span class="fa fa-2x fa-angle-{{#collapsed}}down{{/collapsed}}{{^collapsed}}up{{/collapsed}}"></span>',
            },
            cssClasses: {
                header: "facet-panel-header",
                body: "facet-panel-body",
                footer: "facet-panel-footer",
                collapseButton: "facet-panel-button",
                collapsibleRoot: "facet-panel-root",
                collapsedRoot: "facet-panel-collapsed",
            },

            // make collapsible
            collapsed: () => false,
        })(refinementList);

        const config = {
            // required parameters
            container: "#" + taxCat.key,
            attribute: taxCat.key,

            // optional parameters
            showMore: true,
            showMoreLimit: 200,

            cssClasses: {
                list: "facet-list",
                item: "facet-item",
                showMore: "show-more-button btn btn-primary btn-xs",
                disabledShowMore: "show-more-button-disabled",
            },

            transformItems(items) {
                // hide empty panels
                $("#" + taxCat.key).toggleClass("hidden", items.length === 0);

                // transform facet labels to use names from our categories table
                if (items.length > 0) {
                    _.each(items, (item) => {
                        const taxCatValues =
                            theTaxonomyCategoriesIndexedByKey[taxCat.key]
                                .values;
                        const valueObj = _.find(taxCatValues, {
                            key: item.label,
                        });

                        if (valueObj) {
                            item.label = valueObj.name;
                        }
                    });
                }
                return items;
            },
            templates: {
                item(item) {
                    const { url, label, count, isRefined } = item;

                    // build input
                    const input = $("<input />", {
                        type: "checkbox",
                        checked: isRefined,
                        value: url,
                    });

                    // build checkbox with input and label
                    const checkboxEl = $("<div />", {
                        class: "checkbox",
                    }).append(
                        $("<label />")
                            .append(input)
                            .append(label + " (" + count + ")")
                    );

                    return checkboxEl[0].outerHTML;
                },
            },
        };

        if (taxCat.key === "facet_brand") {
            config.sortBy = (a, b) => {
                // show facet at top of list when selected
                if (a.isRefined && !b.isRefined) {
                    return -1;
                }
                if (!a.isRefined && b.isRefined) {
                    return 1;
                }

                // then sort partners by promotion level
                const obj1 = thePublishersIndexedByName[a.name] || {};
                const obj2 = thePublishersIndexedByName[b.name] || {};

                const p1 =
                    obj1.promotionLevelIndividual + obj1.promotionLevelClass ||
                    0;
                const p2 =
                    obj2.promotionLevelIndividual + obj2.promotionLevelClass ||
                    0;

                // sort in promo order
                if (p1 !== p2) {
                    return p1 > p2 ? -1 : 1;
                }

                // then by alpha
                return a.name < b.name ? -1 : 1;
            };
        }

        if (taxCat.key === "facet_price_band") {
            config.sortBy = (a, b) => {
                // force sort price facets

                const priceWeights = [
                    {
                        weight: 0,
                        name: "free",
                    },
                    {
                        weight: 1,
                        name: "under_20",
                    },
                    {
                        weight: 2,
                        name: "20_to_50",
                    },
                    {
                        weight: 3,
                        name: "50_to_100",
                    },
                    {
                        weight: 4,
                        name: "over_100",
                    },
                ];

                const aWeight = _.find(priceWeights, { name: a.name }).weight;
                const bWeight = _.find(priceWeights, { name: b.name }).weight;

                return aWeight < bWeight ? -1 : 1;
            };
        }

        // return refinement list in panel
        return refinementListWithPanel(config);
    });
}

function buildCurrentRefinementsWidget() {
    return [
        currentRefinements({
            container: "#current-refinements",
            cssClasses: {
                list: "refinement-list",
                label: "refinement-category-label",
                item: "refinement-item m-r-sm m-b-sm",
                category:
                    "refinement-category badge badge-primary m-l-xs m-r-xs",
                categoryLabel: "refinement-label m-l-xs m-r-xs",
                delete: "refinement-remove m-l-xs m-r-xs",
            },
            transformItems(items) {
                // transform facet labels to use names from our categories table
                _.each(items, (item) => {
                    const taxCat =
                        theTaxonomyCategoriesIndexedByKey[item.attribute];
                    const taxCatValues = taxCat.values;

                    // category name
                    item.label = taxCat.name;

                    // each selected refinement
                    _.each(item.refinements, (item) => {
                        // find value with same key
                        const valueObj = _.find(taxCatValues, {
                            key: item.label,
                        });

                        // update label with string name
                        if (valueObj) {
                            item.label = valueObj.name;
                        }
                    });
                });
                return items;
            },
        }),
    ];
}
